import { db } from "../../utils/firebase";

export const getHeaderInfo = async () => {
    const header = db.collection("header").doc("header");
    const doc = await header.get();
    const { audio_src, titles } = doc.data();
    return { audio_src, titles };
}
